import { SxProps, Theme } from "@mui/material";

export const CustomCardStyle: SxProps<Theme> = {
  height: "100%",
  width: "100%",
  borderRadius: "15px",
  border: "none",
};
